import { AlgoliaIndexSuffix } from '@caresend/types';
import { algoliaEnv, createClient } from './init.js';

const bookings = `${algoliaEnv}_${AlgoliaIndexSuffix.BOOKINGS}`;
const denormalizedOrders = `${algoliaEnv}_${AlgoliaIndexSuffix.DENORMALIZED_ORDERS}`;
const draftWaypoints = `${algoliaEnv}_${AlgoliaIndexSuffix.DRAFT_WAYPOINTS}`;
const icd10Codes = `${algoliaEnv}_${AlgoliaIndexSuffix.ICD_10_CODES}`;
const itineraries = `${algoliaEnv}_${AlgoliaIndexSuffix.ITINERARIES}`;
const offices = `${algoliaEnv}_${AlgoliaIndexSuffix.OFFICES}`;
const orders = `${algoliaEnv}_${AlgoliaIndexSuffix.ORDERS}`;
const places = `${algoliaEnv}_${AlgoliaIndexSuffix.PLACES}`;
const products = `${algoliaEnv}_${AlgoliaIndexSuffix.PRODUCTS}`;
const supplyShipments = `${algoliaEnv}_${AlgoliaIndexSuffix.SUPPLY_SHIPMENTS}`;
const supplyTransfers = `${algoliaEnv}_${AlgoliaIndexSuffix.SUPPLY_TRANSFERS}`;
const users = `${algoliaEnv}_${AlgoliaIndexSuffix.USERS}`;
const shifts = `${algoliaEnv}_${AlgoliaIndexSuffix.SHIFTS}`;
const shiftsDescending = `${algoliaEnv}_${AlgoliaIndexSuffix.SHIFTS_DESCENDING}`;
const indexBookings = (apiKey) => createClient(apiKey).initIndex(bookings);
const indexDenormalizedOrders = (apiKey) => createClient(apiKey).initIndex(denormalizedOrders);
const indexDraftWaypoints = (apiKey) => createClient(apiKey).initIndex(draftWaypoints);
const indexICD10Codes = (apiKey) => createClient(apiKey).initIndex(icd10Codes);
const indexItineraries = (apiKey) => createClient(apiKey).initIndex(itineraries);
const indexOffices = (apiKey) => createClient(apiKey).initIndex(offices);
const indexOrders = (apiKey) => createClient(apiKey).initIndex(orders);
const indexPlaces = (apiKey) => createClient(apiKey).initIndex(places);
const indexProducts = (apiKey) => createClient(apiKey).initIndex(products);
const indexShifts = (apiKey) => createClient(apiKey).initIndex(shifts);
const indexShiftsDescending = (apiKey) => createClient(apiKey).initIndex(shiftsDescending);
const indexSupplyShipments = (apiKey) => createClient(apiKey).initIndex(supplyShipments);
const indexSupplyTransfers = (apiKey) => createClient(apiKey).initIndex(supplyTransfers);
const indexUsers = (apiKey) => createClient(apiKey).initIndex(users);

export { indexBookings, indexDenormalizedOrders, indexDraftWaypoints, indexICD10Codes, indexItineraries, indexOffices, indexOrders, indexPlaces, indexProducts, indexShifts, indexShiftsDescending, indexSupplyShipments, indexSupplyTransfers, indexUsers };
